import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import {
  canAddCalculation,
  canAddContract,
  canAddDeliveryNote,
  canAddDemand,
  canAddInboundDeliveryNote,
  canAddInboundInvoice,
  canAddInvoice,
  canAddOffer,
  canAddOrder,
  canConvertCalculation,
  canConvertContract,
  canConvertDeliveryNote,
  canConvertDemand,
  canConvertInboundDeliveryNote,
  canConvertInvoice,
  canConvertOffer,
  canConvertOrder,
  canDeleteCalculation,
  canDeleteContract,
  canDeleteDeliveryNote,
  canDeleteDemand,
  canDeleteInboundDeliveryNote,
  canDeleteInboundInvoice,
  canDeleteInvoice,
  canDeleteOffer,
  canDeleteOrder,
  canEditCalculation,
  canEditContract,
  canEditDeliveryNote,
  canEditDemand,
  canEditInboundDeliveryNote,
  canEditInboundInvoice,
  canEditInvoice,
  canEditOffer,
  canEditOrder,
} from '@work4all/utils/lib/permissions';

import { ALL_PERMISSIONS_TYPES } from '../../constants';
import { PermissionRules, PermissionsConfigsByEntity } from '../types';

const ERP_GRANT_PERMISSION_RULES: PermissionRules = {
  hasPreviewFeature: {
    applyWhenValue: false,
    applyWithPermissions: ['canPreview', 'canEdit', 'canConvert', 'canDelete'],
  },
};

const ERP_DENY_PERMISSION_RULES: PermissionRules = {
  isErpLightUser: {
    applyWhenValue: true,
    applyWithPermissions: ALL_PERMISSIONS_TYPES,
  },
  canAccessErp: {
    applyWhenValue: false,
    applyWithPermissions: ALL_PERMISSIONS_TYPES,
  },
  hasPreviewFeature: {
    applyWhenValue: false,
    applyWithPermissions: [],
  },
};

export const ERP_PERMISSIONS_CONFIGS: PermissionsConfigsByEntity = {
  [Entities.calculation]: {
    permissionsFunctions: {
      canAdd: canAddCalculation,
      canEdit: canEditCalculation,
      canDelete: canDeleteCalculation,
      canConvert: canConvertCalculation,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.offer]: {
    permissionsFunctions: {
      canAdd: canAddOffer,
      canEdit: canEditOffer,
      canDelete: canDeleteOffer,
      canConvert: canConvertOffer,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.contract]: {
    permissionsFunctions: {
      canAdd: canAddContract,
      canEdit: canEditContract,
      canDelete: canDeleteContract,
      canConvert: canConvertContract,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.invoice]: {
    permissionsFunctions: {
      canAdd: canAddInvoice,
      canEdit: canEditInvoice,
      canDelete: canDeleteInvoice,
      canConvert: canConvertInvoice,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.deliveryNote]: {
    permissionsFunctions: {
      canAdd: canAddDeliveryNote,
      canEdit: canEditDeliveryNote,
      canDelete: canDeleteDeliveryNote,
      canConvert: canConvertDeliveryNote,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: {
      canAccessErp: {
        applyWhenValue: false,
        applyWithPermissions: ALL_PERMISSIONS_TYPES,
      },
      /*
       * Light user in the delivery note can do anything normally except converting
       *
       * Full context: https://work4all.atlassian.net/browse/WW-4148
       */
      isErpLightUser: {
        applyWhenValue: true,
        applyWithPermissions: ['canConvert'],
      },
      hasPreviewFeature: {
        applyWhenValue: false,
        applyWithPermissions: ['canAdd', 'canConvert', 'canDelete'],
      },
    },
  },
  [Entities.demand]: {
    permissionsFunctions: {
      canAdd: canAddDemand,
      canEdit: canEditDemand,
      canDelete: canDeleteDemand,
      canConvert: canConvertDemand,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.order]: {
    permissionsFunctions: {
      canAdd: canAddOrder,
      canEdit: canEditOrder,
      canDelete: canDeleteOrder,
      canConvert: canConvertOrder,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.inboundDeliveryNote]: {
    permissionsFunctions: {
      canAdd: canAddInboundDeliveryNote,
      canEdit: canEditInboundDeliveryNote,
      canDelete: canDeleteInboundDeliveryNote,
      canConvert: canConvertInboundDeliveryNote,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.inboundInvoice]: {
    permissionsFunctions: {
      canAdd: canAddInboundInvoice,
      canEdit: canEditInboundInvoice,
      canDelete: canDeleteInboundInvoice,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
  [Entities.reViewModel]: {
    permissionsFunctions: {
      canAdd: canAddInboundInvoice,
      canEdit: canEditInboundInvoice,
      canDelete: canDeleteInboundInvoice,
    },
    grantPermissionRules: ERP_GRANT_PERMISSION_RULES,
    denyPermissionRules: ERP_DENY_PERMISSION_RULES,
  },
};
